<template>
  <div class="main-container scrollbar-y">
    <div class="page-header">
      <div class="page-title">企业认证变更</div>
    </div>
    <div class="page-body">
      <el-form class="ezz-list-search" size="mini" :inline="true">
        <el-form-item label="审核状态">
          <el-select v-model="query.status" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in statusArr" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" style="margin-left: 0;">
          <el-button size="mini" type="success" plain icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="dataList" size="mini" border header-row-class-name="datalist-header" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column type="expand">
          <template v-slot:default="scope">
            <el-form label-width="95px" style="background-color: #efefef;">
              <el-row :gutter="20">
                <el-col :span="20">
                  <el-row :gutter="20" style="padding-top: 15px;">
                    <el-col :span="8">
                      <el-form-item label="归属行业">{{scope.row.industry_name}}</el-form-item>
                      <el-form-item label="企业名称">{{scope.row.name}}</el-form-item>
                      <el-form-item label="企业法人">{{scope.row.legal_person}}</el-form-item>
                      <el-form-item label="联系人">{{scope.row.contacter}}</el-form-item>
                      <el-form-item label="公司地址">{{scope.row.address}}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="企业类别">{{scope.row.company_category}}</el-form-item>
                      <el-form-item label="企业证件号">{{scope.row.license_code}}</el-form-item>
                      <el-form-item label="注册资本">{{scope.row.registered_capital}}</el-form-item>
                      <el-form-item label="联系电话">{{scope.row.phone}}</el-form-item>
                      <el-form-item label="传真">{{scope.row.fax}}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="企业性质">{{scope.row.company_type}}</el-form-item>
                      <el-form-item label="所在地区">{{scope.row.province + ' ' + scope.row.city + ' ' + scope.row.district}}</el-form-item>
                      <el-form-item label="在职人数">{{scope.row.employee_number}}</el-form-item>
                      <el-form-item label="电子邮箱">{{scope.row.email}}</el-form-item>
                      <el-form-item label="邮政编码">{{scope.row.post_code}}</el-form-item>
                    </el-col>
                  </el-row>
                  <el-divider style="background-color: #efefef">企业详情</el-divider>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <div class="form-content" v-html="scope.row.content"></div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="4">
                  <div class="form-attaches-container">
                    <div class="form-attaches-title">企业Logo</div>
                    <div class="avatar-uploader"><img v-if="scope.row.logo" :src="scope.row.logo" class="avatar"></div>
                    <div class="form-attaches-title" style="margin-top: 20px;">企业证件</div>
                    <div class="avatar-uploader"><img v-if="scope.row.business_license" :src="scope.row.business_license" class="avatar"></div>
                    <div class="form-attaches-title" style="margin-top: 20px;">企业形象图</div>
                    <div class="avatar-uploader"><img v-if="scope.row.feature_url" :src="scope.row.feature_url" class="avatar"></div>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="唯一标识 id" width="140" align="center"></el-table-column>
        <el-table-column prop="name" label="企业名称" width="300" align="center"></el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="150" align="center"></el-table-column>
        <el-table-column prop="license_code" label="统一社会信用编码" width="150" align="center"></el-table-column>
        <el-table-column prop="company_category" label="企业类别" width="100" align="center"></el-table-column>
        <el-table-column prop="company_type" label="企业性质" width="80" align="center"></el-table-column>
        <el-table-column prop="legal_person" label="法人" width="80" align="center"></el-table-column>
        <el-table-column prop="registered_capital" label="注册资本(万元)" width="100" align="center"></el-table-column>
        <el-table-column prop="status" label="审核状态" width="120" align="center">
          <template v-slot:default="scope">
            <el-select v-if="scope.row.editstatus" v-model="scope.row.status" placeholder="请选择" style="width: 100%">
              <el-option v-for="item in statusArr" :key="item.key" :label="item.label" :value="item.key"></el-option>
            </el-select>
            <div v-else>
              <span v-if="scope.row.status === '通过'" style="color:#32CD32;">通过</span>
              <span v-else-if="scope.row.status === '未审核'" style="color:#CD853F;">未审核</span>
              <span v-else-if="scope.row.status === '未通过'" style="color:#DC143C;">未通过</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center"></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template v-slot:default="scope">
            <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="handlerDel(scope.row, scope.$index)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 20px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.pn" :page-sizes="[15, 30, 50, 100]" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<style>
.el-table .el-form-item__label {
  font-weight: 700;
}
.el-divider__text {
  background-color: #efefef;
}
.form-attaches-container {
  margin: 0;
}
.form-content {
  padding-left: 20px;
  line-height: 20px;
}
.el-dialog__body {
  padding-bottom: 0;
}
</style>
<script>
import apis from './module.apis.js'
export default {
  name: 'CompanyList',
  data: () => {
    return {
      operate_id: JSON.parse(sessionStorage.getItem('user')).id,
      query: {
        status: '未审核',
        pageSize: 15,
        pn: 1
      },
      statusArr: [
        { key: '未通过', label: '未通过' },
        { key: '通过', label: '通过' },
        { key: '未审核', label: '未审核' }
      ],
      pageStatusCode: 'underreview',
      pageTitle: '',
      // 日期范围
      dataList: [],
      totalCount: 0,
      showAuditDialog: false,
      currentCompany: null
    }
  },
  mounted: function () {
    this.loadData()
  },
  activated: function () {
    this.loadData()
  },

  methods: {
    GetNowDateTime: function () {
      var data = new Date()
      var month = data.getMonth() < 10 ? '0' + (data.getMonth() + 1) : data.getMonth() + 1
      var date = data.getDate() < 10 ? '0' + data.getDate() : data.getDate()
      var hour = data.getHours < 10 ? '0' + data.getHours() : data.getHours()
      var minute = data.getMinutes < 10 ? '0' + data.getMinutes : data.getMinutes()
      var second = data.getSeconds < 10 ? '0' + data.getSeconds : data.getSeconds()
      var value = data.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
      return value
    },
    isEditedable: function (row) {
      this.$set(row, 'editstatus', true)
    },

    loadData: function () {
      const _this = this
      _this.post(apis.GetList, _this.query, function (res) {
        const _json = res.data
        _this.dataList = _json.dataList
        _this.totalCount = _json.dataCount
      })
    },
    handlerAddCompany: function () {
      this.$router.push({ path: '/company/form/', query: { id: '系统自动生成' } })
    },
    handleEdit: function (row) {
      this.$router.push({ path: '/company/form/', query: { id: row.id } })
    },
    handleSearch: function () {
      this.loadData()
    },
    handleSizeChange: function (pageSize) {
      this.query.pn = 1
      this.query.pageSize = pageSize
      this.loadData()
    },
    handleCurrentChange: function (pageIndex) {
      this.query.pn = pageIndex
      this.loadData()
    },
    handlerDel: function (_row, _index) {
      const _this = this
      _this
        .$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          if (_row.id === '系统自动生成') {
            _this.$delete(_this.dataList, _index)
          } else _this.delete(_row)
        })
    },
    delete: function (model) {
      model.deleter_id = this.operate_id
      model.delete_time = this.GetNowDateTime()
      this.handleSave(model)
    },
    handleSave: function (model) {
      const _this = this
      _this.post(apis.UpdateApply, model, function (res) {
        const _json = res.data
        if (_json.status === 'ok') {
          _this.$message({
            message: '操作成功',
            type: 'success'
          })
          _this.loadData()
        } else {
          _this.$message.error('操作失败')
        }
      })
    }
  }
}
</script>